// import ScreenOrientationMgr from "../Fwk/ScreenOrientationMgr.js";
import UtilBrowser from "./UtilBrowser";
import Util from "@/Master/Util";


type Orientation = 'portrait' | 'landscape';


/**
 * 屏幕方向类型枚举
 */
export const OrientType = {
    portraitPrimary: "portrait-primary",       // 竖屏-主方向（设备未旋转，通常是手机或平板的默认竖屏方向）。
    portraitSecondary: "portrait-secondary",   // 竖屏-次方向（设备倒置旋转180度，屏幕顶部朝下）。
    landscapePrimary: "landscape-primary",     // 横屏-主方向（设备顺时针旋转90度，通常是横屏的默认方向）。
    landscapeSecondary: "landscape-secondary", // 横屏-次方向（设备逆时针旋转90度，屏幕顶部朝左）。
    unknown: "unknown",                        // 未知方向
} as const;

type OrientTypeKey = keyof typeof OrientType;
type OrientTypeValue = typeof OrientType[OrientTypeKey];

/**
 * 帧方向管理器类，用于管理和更新屏幕方向。
 */
export default class FrameOrientMgr {
    static curFrame: HTMLElement | null = null;
    static tag: string = "[FrameOrientMgr]";
    static lastLandscapeTag: number = 0; // 默认根据自己的情况 1是横屏幕  2竖屏幕

    // 定义事件监听器的函数引用，便于移除
    private static orientationChangeHandler = () => FrameOrientMgr.handleUpdateOrientation();
    private static resizeHandler = () => FrameOrientMgr.handleUpdateOrientation();

    /**
     * 初始化帧方向管理器
     * @param frame - 要管理方向的帧元素
     */
    static init(frame: HTMLElement): void {
        this.curFrame = frame;
        this.UpdateOrientation();

        if (screen.orientation && screen.orientation.addEventListener) {
            screen.orientation.addEventListener('change', this.orientationChangeHandler);
        } else {
            window.addEventListener('orientationchange', this.orientationChangeHandler);
        }

        window.addEventListener('resize', this.resizeHandler);

        // FullscreenMgr.enterFullscreen();

        // ScreenOrientationMgr.Init();
    }

    /**
     * 移除帧方向管理器的所有事件监听器
     */
    static Remove(): void {
        this.curFrame = null;
        if (screen.orientation && screen.orientation.removeEventListener) {
            screen.orientation.removeEventListener('change', this.orientationChangeHandler);
        } else {
            window.removeEventListener('orientationchange', this.orientationChangeHandler);
        }

        window.removeEventListener('resize', this.resizeHandler);
    }

    /**
     * 获取当前屏幕方向
     */
    static get getOrientation(): OrientTypeValue {
        // console.log(this.tag, `getOrientation`);
        if (screen.orientation && screen.orientation.type) {
            // 使用 Screen Orientation API 获取方向
            return screen.orientation.type as OrientTypeValue;
        } else if (window.orientation !== undefined) {
            // 使用 window.orientation 获取角度并转换为方向
            return this.getOrientationFromAngle(window.orientation);
        } else {
            // 不支持屏幕方向 API 的情况
            console.error("浏览器不支持 Screen Orientation API。");
            return OrientType.unknown;
        }
    }

    /**
     * 私有方法，用于将角度转换为方向类型
     * @param angle - 设备的旋转角度
     * @returns 屏幕方向类型
     */
    private static getOrientationFromAngle(angle: number): OrientTypeValue {
        switch (angle) {
            case 0:
                return OrientType.portraitPrimary;
            case 90:
            case -90:
                return OrientType.landscapePrimary;
            case 180:
                return OrientType.portraitSecondary;
            default:
                return OrientType.unknown;
        }
    }

    /**
     * 处理屏幕方向更新
     */
    static handleUpdateOrientation(): void {
        if (Util.isIOS || UtilBrowser.isSafari) {
            setTimeout(() => {
                FrameOrientMgr.UpdateOrientation();
            }, 300);
        } else {
            FrameOrientMgr.UpdateOrientation();
        }
    }

    static sss(){
        return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
    }

    /**
     * 更新当前的屏幕方向，并根据需要调整帧的布局
     */
    static UpdateOrientation(): void {
        const orient = this.getOrientation;

        if (Util.isLog) {
            console.log(this.tag, `UpdateOrientation=>${orient}`);
        }
        if (FrameOrientMgr.lastLandscapeTag > 0) {
            FrameOrientMgr.SetForcedLandscape(FrameOrientMgr.lastLandscapeTag === 1);
            return;
        }

        switch (orient) {
            case OrientType.portraitPrimary:
            case OrientType.portraitSecondary:
                FrameOrientMgr.SetForcedLandscape(true);
                break;
            case OrientType.landscapePrimary:
            case OrientType.landscapeSecondary:
                FrameOrientMgr.SetForcedLandscape(false);
                break;
            default:
                FrameOrientMgr.SetForcedLandscape(true);
                break;
        }
    }

    /**
     * 设置横屏标签，并更新方向
     * @param open - 是否开启强制横屏
     */
    static SetLandscapeTag(open: boolean): void {
        FrameOrientMgr.lastLandscapeTag = open ? 1 : 2;
        FrameOrientMgr.UpdateOrientation();
    }

    /**
     * 强制设置帧为横屏或竖屏
     * @param open - 是否强制横屏
     */
    static SetForcedLandscape(open: boolean): void {
        if (this.curFrame == null) {
            console.error(`${this.tag} => 当前帧不存在`);
            return;
        }
        let isLandscape = open;
        const frameDom = this.curFrame;
        if (isLandscape) {
            frameDom.style.height = `${window.innerWidth}px`;
            frameDom.style.width = `${window.innerHeight}px`;
            // 通过CSS样式旋转90度
            frameDom.classList.add("forced-landscape-screen");
        } else {
            // 横屏时则正常
            frameDom.style.height = `${window.innerHeight}px`;
            frameDom.style.width = `${window.innerWidth}px`;
            // 通过移除类去掉CSS样式
            frameDom.classList.remove("forced-landscape-screen");
        }
    }
}

